import { PayloadAction } from "@reduxjs/toolkit";

import { FormId } from "../../../../components/enums";
import {
  createGenericUISlice,
  UIState,
} from "../../../../store/HOC/genericUI.slice";

import { ComponentId as ApplicantComponentId } from "./ApplicantData/enums";
import { ComponentId as PerpetratorComponentId } from "./PerpetratorData/enums";

export type FormDataInputs = {
  [FormId.INTRODUCTORY_PERPETRATOR]: {
    [PerpetratorComponentId.PERPETRATOR_REGISTRATION_NUMBER]: string;
    [PerpetratorComponentId.PERPETRATOR_OC_NUMBER]: string;
    [PerpetratorComponentId.PERPETRATOR_NAME]: string;
    [PerpetratorComponentId.PERPETRATOR_SURNAME]: string;
    [PerpetratorComponentId.PERPETRATOR_PHONE]: string;
    [PerpetratorComponentId.PERPETRATOR_EMAIL]: string;
  };
  [FormId.INTRODUCTORY_APPLICANT]: {
    [ApplicantComponentId.APPLICANT_NAME]: string;
    [ApplicantComponentId.APPLICANT_SURNAME]: string;
    [ApplicantComponentId.APPLICANT_PHONE]: string;
    [ApplicantComponentId.APPLICANT_EMAIL]: string;
  };
};

export type IntroductoryPerpetratorFormInputs = FormDataInputs[FormId.INTRODUCTORY_PERPETRATOR];
export type IntroductoryApplicantFormInputs = FormDataInputs[FormId.INTRODUCTORY_APPLICANT];

type IntroductoryState = {
  data: FormDataInputs;
  ui: UIState;
};

const initialState: IntroductoryState = {
  data: {
    [FormId.INTRODUCTORY_PERPETRATOR]: {
      [PerpetratorComponentId.PERPETRATOR_REGISTRATION_NUMBER]: "",
      [PerpetratorComponentId.PERPETRATOR_OC_NUMBER]: "",
      [PerpetratorComponentId.PERPETRATOR_NAME]: "",
      [PerpetratorComponentId.PERPETRATOR_SURNAME]: "",
      [PerpetratorComponentId.PERPETRATOR_PHONE]: "",
      [PerpetratorComponentId.PERPETRATOR_EMAIL]: "",
    },
    [FormId.INTRODUCTORY_APPLICANT]: {
      [ApplicantComponentId.APPLICANT_NAME]: "",
      [ApplicantComponentId.APPLICANT_SURNAME]: "",
      [ApplicantComponentId.APPLICANT_PHONE]: "",
      [ApplicantComponentId.APPLICANT_EMAIL]: "",
    },
  },
  ui: {
    validated: false,
  },
};

const introductorySlice = createGenericUISlice({
  name: "@OC/vehicle/introductory",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<FormDataInputs>) => {
      state.data[FormId.INTRODUCTORY_PERPETRATOR] = {
        ...initialState.data[FormId.INTRODUCTORY_PERPETRATOR],
        ...action.payload[FormId.INTRODUCTORY_PERPETRATOR],
      };
      state.data[FormId.INTRODUCTORY_APPLICANT] = {
        ...initialState.data[FormId.INTRODUCTORY_APPLICANT],
        ...action.payload[FormId.INTRODUCTORY_APPLICANT],
      };
      state.ui.validated = true;
    },
  },
});

export const {
  setData: setVehicleIntroductoryFormData,
  setUIField,
  setUIObjectField,
} = introductorySlice.actions;

export const { reducer } = introductorySlice;
